import { createFileRoute } from '@tanstack/react-router'

import Banking from '@/features/services/pages/banking'

export const Route = createFileRoute('/_shell/banking')({ component: Banking })
